import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import postPaymentOrderTransaction from './postPaymentOrderTransaction';
import {
  ICreateOrderTransactionPayload,
  ICreateOrderTransactionResponse,
} from './types';

const usePostPaymentOrderTransaction = (
  handleAfterSuccess?: (data: ICreateOrderTransactionResponse) => void,
) => {
  const {isLoading, mutate, isSuccess} = useMutation<
    ICreateOrderTransactionResponse,
    AxiosError<IAxiosErr>,
    ICreateOrderTransactionPayload
  >({
    mutationFn: postPaymentOrderTransaction,
    onSuccess: data => handleAfterSuccess?.(data),
    onError: error => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostPaymentOrderTransaction;
